import { DataBean } from "../DataBean";

export class QualityInspectionLoteItem extends DataBean {

  public async getQualityInspectionLoteItemCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInspectionLoteItemCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityInspectionLoteItemRender( page: number, rows: number, properties: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityInspectionLoteItemRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async deleteQualityInspectionLoteItem(idqualityinspectionloteitem: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInspectionLoteItem_Number", [idqualityinspectionloteitem]);
  }

  public async updateQualityInspectionLoteItem(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInspectionLoteItem_updateQualityInspectionLoteItem_com.orange.finance.processcontract.bean.QualityInspectionLoteItem",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInspectionLoteItem",
        },
      ]
    );
  }
}
